export enum MasterStatusID {
	AP = 1,
	E = 2,
	G = 4,
	NA = 5,
	AC = 6,
	WL = 7,
	W = 8,
	RE = 9,

	// Secondary Enrolled Statuses
	RS = 70,
	ES = 71,
	DS = 72,
	CS = 73
}

export enum MasterStatusDescription {
	AP = 'Applied',
	E = 'Enrolled',
	G = 'Graduated',
	NA = 'Not Attending',
	AC = 'Accepted',
	WL = 'Wait List',
	W = 'Withdrawn',
	RE = 'Re-Enrolled',

	// Secondary Enrolled Statuses
	RS = 'Requested Secondary',
	ES = 'Enrolled Secondary',
	DS = 'Dropped Secondary',
	CS = 'Completed Secondary'
}
